// Las funciones habilitadas vienen resueltas desde el backend (config/features.js) en tenant.features.modules.
export function hasFeature(tenant, user, key) {
  if (user?.role === 'super_admin') return true;
  return !!tenant?.features?.modules?.[key]?.[user?.role];
}

// Rutas del CRM y la función que las habilita (orden = prioridad para la página de inicio)
export const ROUTE_FEATURES = [
  { path: '/', feature: 'dashboard' },
  { path: '/leads', feature: 'leads' },
  { path: '/datasets', feature: 'datasets' },
  { path: '/inbox', feature: 'inbox' },
  { path: '/campaigns', feature: 'campaigns' },
  { path: '/templates', feature: 'templates' },
  { path: '/reports', feature: 'reports' },
  { path: '/bot', feature: 'bot' },
  { path: '/channels', feature: 'channels' },
  { path: '/settings', feature: 'settings' },
];

export function firstAllowedPath(tenant, user) {
  const r = ROUTE_FEATURES.find(x => hasFeature(tenant, user, x.feature));
  return r ? r.path : null;
}
